import React from "react"
import { styled } from "@mui/material/styles"

import { Box, Stack } from "@mui/material"

import Image from "@components/image"
import { SIDEBAR_WIDTH, handleNavigation } from "./utils"
import useGetMenuList from "./use-get-menu-list"
import { useGetChat } from "@hooks/index"

import CarPaddyLogo from "@assets/images/carpaddy-logo.png"
import MenuRenderer from "./components/menu-renderer"

const CustomBox = styled(Box)<any>(
  ({ theme, fixed }) => `
      position: fixed ;
      width: ${SIDEBAR_WIDTH}px;
      height: 100vh; 
      top: 0;
      bottom: 0;
      left: 0 ;
      right: 0;
      padding : 32px 0px 0px 32px;
      color: ${theme.palette.secondary.main};
      background-color: ${theme.palette.secondary.contrastText};

       ${
         fixed !== "true" &&
         `${theme.breakpoints.down("md")}{ 
        display: none ;
      }`
       }

  `
)

const ScrollBox = styled(Box)(
  ({ theme }) => `
      overflow: auto;
      height: 100%;
      padding-right: 32px;
      padding-bottom: 32px;

      &::-webkit-scrollbar {
        width: 5px; 
        margin: -10px;
      }
      
        /* Track */
      &::-webkit-scrollbar-track {
        background: none;
        border-radius: 10px;
      }
      
      /* Track on hover */
      &::-webkit-scrollbar-track:hover {
        background: #f1f1f1;
      }
      
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: none;
        border-radius: 10px;
      }
      
      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: ${theme.palette.primary.main};
      }
  `
)

const LogoBox = styled(Box)(
  ({ theme }) => `
    position: sticky; 
    top: 0px; 
    padding-bottom: 16px;
    background-color: ${theme.palette.background.paper};
  `
)

const getCurrentRoute = (pathname: string, route: string) => {
  return route === pathname ? "true" : "false"
}

export const Sidebar = (props: any) => {
  const { menuList, adminMenuList } = useGetMenuList()
  const { ChatComponent } = useGetChat()
  const itsCartMenu = (menu: any, submenu: any) =>
    menu.menu === "3" && submenu.id === 0

  return (
    <CustomBox fixed={props?.fixed?.toString()}>
      <ScrollBox>
        <Stack spacing={2}>
          <LogoBox>
            <Image src={CarPaddyLogo} width={"70%"} alt={"CarPaddy logo"} />
          </LogoBox>
          {adminMenuList ? (
            <MenuRenderer
              menu={adminMenuList}
              handleNavigation={handleNavigation}
              jumpTo={props.jumpTo}
              itsCartMenu={itsCartMenu}
              getCurrentRoute={getCurrentRoute}
            />
          ) : null}
          {menuList.map((menu: any, i: number) =>
            menu.menu !== "2" ? (
              <MenuRenderer
                key={i}
                menu={menu}
                handleNavigation={handleNavigation}
                jumpTo={props.jumpTo}
                itsCartMenu={itsCartMenu}
                getCurrentRoute={getCurrentRoute}
              />
            ) : null
          )}
        </Stack>
      </ScrollBox>
      <ChatComponent />
    </CustomBox>
  )
}

export default Sidebar
